import React, { FC, useCallback, useMemo } from 'react';

import { FormikProps } from 'formik';

//components
import BasicButton from '../../../../../components/buttons/basicButton';
import CMSTypeInput from '../../../../../components/formulas/settings/CMSType/CMSTypeInput';
import styled from 'styled-components';

//constants
import aampeTheme from '../../../../../constants/aampeTheme';

// models
import {
    CartFilterFormValues,
    CMSFilterType,
} from '../../../../../models/cms-placeholder.model';

import CMSPlaceholderRadioOptions from './CMSPlaceholderRadioOptions';

interface CMSPlaceholderTypeProps {
    formikProps: FormikProps<CartFilterFormValues>;
    handleClose: () => void;
    OnNextClick: () => void;
    isDisabled: boolean;
}
const CMSPlaceholderType: FC<CMSPlaceholderTypeProps> = ({
    formikProps,
    handleClose,
    OnNextClick,
    isDisabled = false,
}) => {
    const { values } = formikProps;

    const buttonType = useMemo<'submit' | 'button'>(() => {
        if (values.cms_filter_type === CMSFilterType.SPECIFIC) {
            return 'button';
        }
        return 'submit';
    }, [values]);

    const buttonName = useMemo<string>(() => {
        if (values.cms_filter_type === CMSFilterType.SPECIFIC) {
            return 'Next';
        }
        return 'Save';
    }, [values]);

    const buttonDisable = useMemo<boolean>(() => {
        if (isDisabled) {
            if (values.cms_filter_type === CMSFilterType.SPECIFIC) {
                return false;
            }
            return isDisabled;
        } else {
            return false;
        }
    }, [isDisabled, values]);

    const onClick = useCallback(() => {
        if (buttonType === 'button') {
            OnNextClick();
        }
    }, [buttonType, OnNextClick]);

    return (
        <>
            <CMSTypeInput
                formikProps={formikProps as any}
                isDisabled={isDisabled}
            />

            <FilterOption>
                <Heading>Insert Items</Heading>
                <CMSPlaceholderRadioOptions
                    formikProps={formikProps}
                    isDisabled={isDisabled}
                />
            </FilterOption>

            <ActionContainer>
                <StyledButton
                    isPrimary={false}
                    name="Cancel"
                    action={handleClose}
                />
                <StyledButton
                    isDisabled={buttonDisable}
                    isPrimary
                    name={buttonName}
                    type={buttonType}
                    action={onClick}
                />
            </ActionContainer>
        </>
    );
};

export default CMSPlaceholderType;

const FilterOption = styled.div({
    display: 'flex',
    flexDirection: 'column',
});

const Heading = styled.div({
    fontSize: aampeTheme.size.font.default,
    lineHeight: '20px',
    fontWeight: 500,
});

const StyledButton = styled(BasicButton)({
    borderRadius: aampeTheme.borderRadius.default,
    fontWeight: 500,
    fontSize: aampeTheme.size.font.default,
    lineHeight: '18px',
    padding: aampeTheme.spacing4(3, 11),
});

const ActionContainer = styled.div({
    display: 'flex',
    justifyContent: 'end',
    gap: aampeTheme.spacing4(4),
});
